module.exports = __webpack_public_path__ + "static/media/CIPRES_ARAYAN.010e3d72.jpg";